import { Skeleton } from "~/atoms/skeleton";
import { Table, TableBody, TableCell, TableRow } from "~/atoms/table";

interface Props {
  rows: number;
  columns: number;
  wrapperClassName?: string;
}

export function TableSkeleton({ rows, columns, wrapperClassName }: Props) {
  return (
    <Table wrapperClassName={wrapperClassName}>
      <TableBody>
        {Array.from({ length: rows }).map((_, row) => (
          <TableRow key={row}>
            {Array.from({ length: columns }).map((_, column) => (
              <TableCell key={column}>
                <Skeleton className="h-4 w-24" />
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
